export default __webpack_public_path__ + "images/5bc5f6845d02676e38152a817780f8d9-childrenandyouth.webp";